import { ReactNode } from "react";

import { useAnalytics } from "../../../components";

import { TeamCard, DefaultCard } from "./Card.styles";

export type CardProps = {
    readonly href: string;
    readonly containerId: string;
    readonly containerType: string;
    readonly children: ReactNode | ReactNode[];
    readonly theme?: string;
    readonly label?: string;
    readonly labelEnglish?: string;
    readonly imageAlt?: string;
};

const Card = ({
    theme,
    href,
    children,
    containerId,
    containerType,
    label,
    labelEnglish,
    imageAlt
}: CardProps) => {
    const { sendTrackEvent } = useAnalytics();
    const props = {
        href,
        title: label,
        onClick: () =>
            sendTrackEvent("clickedCard", {
                event: "clicked",
                eventComponent: "card",
                eventContainer: containerType,
                label,
                labelEnglish,
                uuid: containerId,
                imageAlt,
                href,
                theme
            })
    };

    switch (theme) {
        case "Team card":
            return (
                <TeamCard {...props} data-uuid={containerId}>
                    <>{children}</>
                </TeamCard>
            );
        default:
            return (
                <DefaultCard {...props} data-uuid={containerId}>
                    <>{children}</>
                </DefaultCard>
            );
    }
};

export default Card;
